import { createUsePermissions } from "./createUsePermissions";

export const useCategoriesPermissions = createUsePermissions("pb.category");
